import { PledgePotStore } from '@stores/pledge-pot.store';
import apiResponse from '@stores/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { Duration } from 'luxon';

export type PledgePotView = {
  potValue: number;
  pledgeAmount: number;
  remainingPledgeAmount: number | null;
};

export class PledgePotViewCreator {
  constructor(private readonly store: PledgePotStore = new PledgePotStore()) {}

  async createView(groupId: number): Promise<PledgePotView> {
    const result = await apiResponse.handleApiResponse<{
      potValue: number;
      pledgeAmount: number;
      remainingPledgeAmount: number | null;
    }>(async () => await new PledgePotStore().getPledgePot(groupId));

    return {
      potValue: result.potValue,
      pledgeAmount: result.pledgeAmount,
      remainingPledgeAmount: result.remainingPledgeAmount,
    };
  }
}

export const usePledgePotViewCreator = (groupId: number) =>
  useQuery({
    queryKey: [PledgePotViewCreator.name, groupId],
    queryFn: () => new PledgePotViewCreator().createView(groupId),
    staleTime: Duration.fromObject({ minutes: 1 }).milliseconds,
    enabled: groupId > 0,
  });
